<template>
  <div>
 <v-file-input
	v-model='theFile'
	required :rules="[value => !!value  || 'Please Select a file']"
	@change='convertoBase64'
	label="File input"></v-file-input>
	<v-btn
	          color="green darken-1"
	          text
            :disabled='!theFile'
	          @click="uploadDoc()">Attach File</v-btn>      
  </div>
</template>

<script>
import { uploadFile } from '../helper/firestore'

export default {
    data(){
        return{
            theFile : null,
        }
    },
    methods: {
         convertoBase64(f){
			if (f === null){return;}
      var reader = new FileReader();
	    reader.onload = ((theFile) => {
	      this.theFile = theFile;
	      return (e) => {
	        var binaryData = e.target.result;
	        this.PedigreeUploadFile = window.btoa(binaryData);
        };
        })(f);
      reader.readAsBinaryString(f);
    },
    		uploadDoc(){
		  uploadFile(
	      {
      baseString : this.PedigreeUploadFile,
		  selectedDocType : this.selectedDocumentType,
		  fileType : this.theFile.type,
		  fileName : this.theFile.name
	    }, (result) => {
          this.replyMessage = "attached "+ this.theFile.name
          this.sendReply();
          this.theFile = null;
          this.selectedDocumentType = null;
          setTimeout(()=>{ this.$emit('uploadcomplete') }, 3000);
        }
      )
			// TODO:
			// add new message with attached file URL
			// add filePath to message Object
      this.uploaddialog = false
    },
    }
}
</script>

<style>

</style>